import { render, staticRenderFns } from "./criteria-chips.vue?vue&type=template&id=7ef939d1&scoped=true&"
import script from "./criteria-chips.vue?vue&type=script&lang=js&"
export * from "./criteria-chips.vue?vue&type=script&lang=js&"
import style0 from "./criteria-chips.vue?vue&type=style&index=0&id=7ef939d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef939d1",
  null
  
)

export default component.exports